import React, { PureComponent } from 'react'

class Footer extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {        }
    }

    render() {
        return (
            <footer class="footer">
                <div class="d-sm-flex justify-content-center justify-content-sm-between">
                    <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2025.<a href="#">Data Beautifier Admin</a>. All rights reserved.</span>
                </div>
            </footer>
        )
    }
}
export default Footer